import { render, staticRenderFns } from "./values-table.vue?vue&type=template&id=7bfb1724"
import script from "./values-table.vue?vue&type=script&lang=js"
export * from "./values-table.vue?vue&type=script&lang=js"
import style0 from "./values-table.vue?vue&type=style&index=0&id=7bfb1724&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports